var handlers = []

const eventBus = {
  trigger(name, eventData) {
    if (handlers === null || handlers.length === 0) {
      console.log('trigger event:' + name + ', but has not handlers');
      return;
    }
    for (let i = 0, len = handlers.length; i < len; i++) {
      var handler = handlers[i]
      if (handler.eventName === name) {
        handler.handle(eventData)
      }
    }

  },
  subscribe(eventName, handler) {
    if (typeof handler !== 'function') {
      throw 'handler is not function';
      return
    }
    handlers.push({
      eventName: eventName,
      handle: handler
    });

  }
}

export default eventBus



// WEBPACK FOOTER //
// ./src/js/eventBus.js